window.ffNativeMounts ??= {};
window.ffNativeMounts["support"] = (controller) => {
    (() => {
        'use strict';
        const filters = [...document.querySelectorAll('[data-filter]')];
        const guides = [...document.querySelectorAll('.s-tutorial')];
        const count = document.querySelector('.s-count');
        const closeVideo = (guide, returnFocus = false) => {
            const trigger = guide.querySelector('[data-video]');
            const player = guide.querySelector('.s-player');
            player.querySelector('.s-embed').replaceChildren();
            player.hidden = true;
            trigger.setAttribute('aria-expanded', 'false');
            if (returnFocus)
                trigger.focus();
        };
        const filterGuides = task => {
            let visible = 0;
            filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === task)));
            guides.forEach(guide => {
                const show = task === 'all' || guide.dataset.task === task;
                if (!show)
                    closeVideo(guide);
                guide.hidden = !show;
                if (show)
                    visible += 1;
            });
            count.textContent = `${visible} ${visible === 1 ? 'guide' : 'guides'}`;
        };
        filters.forEach(button => button.addEventListener('click', () => filterGuides(button.dataset.filter), Object.assign({}, { signal: controller.signal }, { signal: controller.signal })));
        document.querySelectorAll('[data-show-guide]').forEach(link => link.addEventListener('click', () => filterGuides(link.dataset.showGuide), Object.assign({}, { signal: controller.signal }, { signal: controller.signal })));
        document.querySelectorAll('[data-video]').forEach(trigger => {
            trigger.setAttribute('role', 'button');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.addEventListener('click', event => {
                if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
                    return;
                event.preventDefault();
                const guide = trigger.closest('.s-tutorial');
                const player = guide.querySelector('.s-player');
                if (!player.hidden) {
                    player.querySelector('iframe')?.focus();
                    return;
                }
                guides.filter(other => other !== guide).forEach(other => closeVideo(other));
                const iframe = document.createElement('iframe');
                iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(trigger.dataset.video)}?autoplay=1&rel=0`;
                iframe.title = trigger.dataset.title;
                iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
                iframe.allowFullscreen = true;
                iframe.referrerPolicy = 'strict-origin-when-cross-origin';
                player.querySelector('.s-embed').append(iframe);
                player.hidden = false;
                trigger.setAttribute('aria-expanded', 'true');
                player.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                iframe.focus({ preventScroll: true });
            }, Object.assign({}, { signal: controller.signal }, { signal: controller.signal }));
            trigger.addEventListener('keydown', event => {
                if (event.key === ' ') {
                    event.preventDefault();
                    trigger.click();
                }
            }, Object.assign({}, { signal: controller.signal }, { signal: controller.signal }));
        });
        document.querySelectorAll('[data-close-video]').forEach(button => button.addEventListener('click', () => closeVideo(button.closest('.s-tutorial'), true), Object.assign({}, { signal: controller.signal }, { signal: controller.signal })));
        const requestForm = document.querySelector('#support-request');
        if (requestForm)
            requestForm.hidden = false;
    })();
};
